import { useShallow } from 'zustand/react/shallow';
import { createBase, createSelectors } from './base';
import { getLabelParts, generateLinkPath } from '../utils/helper';
import { request } from "@/utils/useRequest";
import { nanoid } from 'nanoid';
const node_width = 100;
const node_height = 30;

function mergeArraysByType(array1, array2) {
  // 使用 reduce 方法遍历 array2，并根据 type 属性合并 array1 中的元素
  return array2.map(item2 => {
    // 查找 array1 中 type 相同的项
    const item1 = array1.find(item1 => item1.type === item2.type);
    // 如果找到匹配的项，合并这两个对象
    if (item2.name == "" && item1.name != null) item2.name = item1.name;
    if (item1) {
      return { ...item1, ...item2 };
    }
    // 如果没有找到匹配的项，只返回 array2 中的项
    return item2;
  });
  //return t1;
}

// 1.初始状态
// define the initial state
const initialState = {
    chart: null,
    outer: null,
    eventLayer:null,
    gridLayer:null,
    groupLayer:null,
    groupSelectLayer:null,
    linkLayer:null,
    dragGroupLayer:null,
    junctionLayer:null,
    nodeLayer:null,
    divContainerRef: null,
    flowPositions: {}, // 存储每个流程的滚动位置 {flowId: {top, left}}
    mouseOnNode:null,
    selectedNode:null,  //结构：{id,offsetX,offsetY}
    selectedLine:null, //结构: {}
    nodes: [],
    activeFlow:null,
    node_map:{},
    links:[],
    flowlist:[],
    new_link:null, //结构：{source:{id,x,y},target:{x,y}}
    op_mode: null, //操作状态 1：建立链接 2:移动节点 3:画选区
    lassoStart:null, //选框开始点
    lassoEnd:null, //选框结束点
    movingSet:[], //选中的节点id组
    mousePt:null, //当前鼠标位置
    copiedNodes:[], //复制的节点
    loading:false,
    isDeploying:false,
    registerNodes: [{type:"inject",icon:"inject.svg",props:{cron:"1/10 * * * * *"},formid:11,color:"#a6bbcf",inputs:0,outputs:1,name:"注入"},
      {type:"lua",icon:"function.svg",formid:69,color:"#fdd0a2",inputs:1,outputs:1,name:"lua"},
      {type:"http_handler",icon:"white-globe.svg",props:{path:"/dynamic/xxx/xxx"},formid:68,color:"#e7e7ad",inputs:0,outputs:1,name:"http in"},
      {type:"request",icon:"white-globe.svg",props:{url:"/dynamic/xxx/xxx"},formid:10,color:"#e7e7ad",inputs:1,outputs:2,name:"http请求"},
      {type:"response",icon:"white-globe.svg",color:"#e7e7ad",inputs:1,outputs:1,align: "right",name:"response"},
      {type:"writefile",icon:"file-in.svg",props:{path:"./flow/test.json"},formid:70,color:"burlywood",inputs:1,outputs:1,name:"writefile"},
      {type:"debug",icon:"debug.svg",color:"#87a980",inputs:1,outputs:0,align: "right",name:"debug"},
      {type:"switch",icon:"switch.svg","props":{"property":"success","propertyType":"msg","conditions":[{"id":1,"cond":"==","type":"bool","value":"true"}]},formid:5,color:"#e2d96e",inputs:1,outputs:1,name:"条件分支"},
      {type:"gs_auth",icon:"logo.svg",formid:14,color:"darksalmon",inputs:1,outputs:2,name:"贯石认证"},
      {type:"wechat_pay",icon:"white-globe.svg",formid:12,color:"#7ac6cb",inputs:1,outputs:1,name:"微信支付"},
      {type:"wechat_pay_decode",icon:"white-globe.svg",props:{appId:"xxxxxxxxxxxxxx"},formid:12,color:"#7ac6cb",inputs:1,outputs:1,name:"微信支付回调解码"},
      {type:"wechat_pay_refund",icon:"white-globe.svg",props:{appId:"xxxxxxxxxxxxxx"},formid:12,color:"#7ac6ff",inputs:1,outputs:1,name:"微信退款"},
      {"type":"oidc_callback","icon":"white-globe.svg","props":{"authorization_url":"https://git.wsc.tech/oauth/authorize","token_url":"https://git.wsc.tech/oauth/token","logout_url":"http://localhost:3000/logout","scopes":"openid,email,profile","client_id":"9db5bfc177c993c6487d3a6d74e196e59f28003d53b2783955054a411a0e136b","client_secret":"599bc16b01c61d36e743c41f046944c068e7fed9104330597d3166531871460e","server_url":"https://git.wsc.tech/","redirect_url":"http://localhost:3000/auth/callback"},"formid":13,"color":"#7ac6ff","inputs":1,"outputs":1,"name":"OAuth2认证"},
      {type:"comment",icon:"comment.svg",formid:3,color:"#ffffff",inputs:0,outputs:0,name:"注释"},
      {type:"mqtt-in",icon:"bridge.svg",formid:4,color:"rgb(216, 191, 216)",inputs:0,outputs:1,name:"接收MQTT"},
      {type:"mqtt-out",icon:"bridge.svg",formid:7,color:"rgb(216, 191, 216)",inputs:1,outputs:0,name:"发送MQTT"},
      {type:"mqtt-broker",icon:"bridge.svg",formid:6,props: {keep_alive: 60, clean_session: true, port: 1881}, drawable: false, color:"rgb(216, 191, 216)",inputs:0,outputs:0,name:"MQTT Broker"},
      {type:"redis-broker",icon:"redis.png",formid:8,props: {port: 6379}, drawable: false, color:"rgb(216, 191, 216)",inputs:0,outputs:0,name:"Redis Broker"},
      {type:"redis-cmd",icon:"redis.png",formid:9,color:"rgb(216, 191, 216)",inputs:1,outputs:1,name:"Redis Cmd"},
      {type:"modbus-client",icon:"white-globe.svg",formid:9,color:"rgb(216, 191, 216)",inputs:1,outputs:1,name:"Modbus Client"},
    ]
};

// 提取 generateLinks 为独立函数
function generateLinks(nodes, activeFlow) {
  let _nodeMap = {};
  let _nodes = nodes.filter(m => m.z === activeFlow);
  _nodes.forEach(node => {
    const labelParts = getLabelParts(node?.name || "", "red-ui-flow-node-label");
    const width = Math.max(node_width, 20 * (Math.ceil((labelParts.width + 50 + (node.inputs > 0 ? 7 : 0)) / 20)));
    const height = Math.max(6 + 24 * labelParts.lines.length, (node.outputs || 0) * 15, 30);
    node.w = width;
    node.h = height;
    _nodeMap[node.id] = node;
  });

  let links = [];
  _nodes.forEach(n => {
    if (n.wires) {
      for (let w1 = 0; w1 < n.wires.length; w1++) {
        var wires = Array.isArray(n.wires[w1]) ? n.wires[w1] : [n.wires[w1]];
        for (let w2 = 0; w2 < wires.length; w2++) {
          if (_nodeMap.hasOwnProperty(wires[w2])) {
            if (n.z === _nodeMap[wires[w2]].z) {
              var link = { id: `${n.id}_${w1}_${_nodeMap[wires[w2]].id}`, source: n, sourcePort: w1, target: _nodeMap[wires[w2]] };
              links.push(link);
            } else {
              console.log("Warning: dropping link that crosses tabs:", n.id, "->", _nodeMap[wires[w2]].id);
            }
          }
        }
      }
    }
  });

  return { links, node_map: _nodeMap };
}

// 2.定义基础store
const useEditorStoreBase = createBase(
  (set, get) => ({
    ...initialState,
    // undefined和'example/setName'主要用于redux devtools友好展示
    init: (chart,
      outer,
      eventLayer,
      gridLayer,
      groupLayer,
      groupSelectLayer,
      linkLayer,
      dragGroupLayer,
      junctionLayer,
      nodeLayer,
      divContainerRef,
    ) => set((state) => {
        return {
          ...state,
          chart,
          outer,
          eventLayer,
          gridLayer,
          groupLayer,
          groupSelectLayer,
          linkLayer,
          dragGroupLayer,
          junctionLayer,
          nodeLayer,
          divContainerRef,
        };
      }, undefined, 'useEditor/init'),
    reset: () => set((state) => { state = initialState }, undefined, 'example/reset'),
    load_flow_data: async () => {
      set(state => {state.loading = true; state.isDeploying = false;});
      const result = await request("/api/v5/private/flow/all", "GET", "json", {});
      if(result.success) {
        set(state => {
          state.loading = false;
          state.isDeploying = false;
          state.nodes = mergeArraysByType(state.registerNodes,result.data);
        });
      } else {
        set(state => {state.loading = false; state.isDeploying = false;});
      }
    },
    //拖拽新建节点
    addNode: (nodeData) => {
      set(state => {
        //计算补充实际的节点w => width
        const labelParts = getLabelParts(nodeData?.name || "", "red-ui-flow-node-label");
        const width = Math.max(node_width, 20 * (Math.ceil((labelParts.width + 50 + (nodeData.inputs > 0 ? 7 : 0)) / 20)));
        const height = Math.max(6 + 24 * labelParts.lines.length, (nodeData.outputs || 0) * 15, 30);
        nodeData.w = width;
        nodeData.h = height;
        nodeData.z = state.activeFlow;
        let targetNode = state.registerNodes.find(item => item.type == nodeData.type);
        state.node_map[nodeData.id] = {...targetNode, ...nodeData};
      });
    },
      removeNode: (nodeId) => {
        set(state => {
           const map = {...state.node_map};
           delete map[nodeId];
           state.node_map = map;
        }, undefined, 'editor/removeNode');
      }, // removeNode
    //移动指定节点
    moveNode: (x, y) => {
      set(state => {
        // 更新移动节点目标位置
        const selectedNode = state.selectedNode;
        const deltaX = x - selectedNode.offsetX - state.node_map[selectedNode.id].x;
        const deltaY = y - selectedNode.offsetY - state.node_map[selectedNode.id].y;

        state.movingSet.forEach(nodeId => {
          state.node_map[nodeId].x += deltaX;
          state.node_map[nodeId].y += deltaY;
        });

        // 更新依赖这些目标的所有连线的对象
        let links = state.links;
        links.forEach(link => {
          if (state.movingSet.includes(link.source.id)) {
            link.source = state.node_map[link.source.id];
          }
          if (state.movingSet.includes(link.target.id)) {
            link.target = state.node_map[link.target.id];
          }
        });
        state.links = links;
      });
    },
    moveNewLink: (dx, dy) => {
      set(state => {
        if (state.new_link != null) {
          //更新移动节点目标位置
          state.new_link.target = { x: dx, y: dy };
        }
      });
    },
    updateNewLink: (sid,sx, sy,index, dx, dy, dir) => {
      set(state => {
        //更新移动节点目标位置
        state.new_link = { dir:dir, source: { id:sid, x: sx, y: sy },sourcePort:index, target: { x: dx, y: dy } };
      });
    },
    clearNewLink: () => {
      set(state => { state.new_link = null });
    },
    SetMouseOnNode: (key) => {
      set(state => {
        state.mouseOnNode = key;
      });
    },
    setSelectedNode:(key,offsetX,offsetY) => {
      set(state => {
        if (key && !state.movingSet.includes(key)) {
          state.movingSet = [key];
        }
        state.selectedNode = {id:key,offsetX,offsetY};
      })
    },
    AddLink:() => {
      set(state=>{
        if(state.mouseOnNode && state.mouseOnNode !== state.new_link.source.id) {
          console.log("添加连接",state.new_link.source.id,state.mouseOnNode);
          console.log("添加链接前",JSON.parse(JSON.stringify(state.node_map)));
          if (state.new_link.dir == "-1") {
            //从目标节点->源节点
            // 判断目标节点是否可以连接
            if(state.node_map[state.mouseOnNode].outputs == 0) return;
            //添加连接关系
            state.links = [...state.links,
              {
                id: state.node_map[state.mouseOnNode].id + "-" + state.node_map[state.new_link.source.id].id
                , source: state.node_map[state.mouseOnNode], sourcePort: 1, target: state.node_map[state.new_link.source.id]
              }];
              //源节点的wires添加关系
              if(state.node_map[state.mouseOnNode].wires.length == 0) state.node_map[state.mouseOnNode].wires = [[]];
              state.node_map[state.mouseOnNode].wires[0].push(state.new_link.source.id);
          } else {
            //从源节点输出框->目标节点输入口
            // 判断目标节点是否可以连接
            if(state.node_map[state.mouseOnNode].inputs == 0) return;
            state.links = [...state.links,
            {
              id: state.node_map[state.new_link.source.id].id + `_${state.new_link.sourcePort}` +"_" + state.node_map[state.mouseOnNode].id
              , source: state.node_map[state.new_link.source.id], sourcePort: state.new_link.sourcePort, target: state.node_map[state.mouseOnNode]
            }];
            //源节点的wires添加关系
            if(state.node_map[state.new_link.source.id].wires.length <= (state.new_link.sourcePort+1)) {
              state.node_map[state.new_link.source.id].wires = state.node_map[state.new_link.source.id].wires.concat(Array(state.new_link.sourcePort - state.node_map[state.new_link.source.id].wires.length + 1).fill([]));
            }
            state.node_map[state.new_link.source.id].wires[state.new_link.sourcePort].push(state.mouseOnNode);
          }
          console.log("添加链接后",JSON.parse(JSON.stringify(state.node_map)));
        }
      });
      //var link = { source: n, sourcePort: w1, target: _nodeMap[wires[w2]] };
    },
    setOpMode:(status) => {
      set(state => { state.op_mode = status; });
    },
    removeSelected: () => {
      set(state => {
        if (state.selectedNode) {
          //删除相关的连接
          state.links = state.links.filter(link => {
            return !(link.source.id === state.selectedNode.id || link.target.id === state.selectedNode.id);
          });

          if (state.node_map.hasOwnProperty(state.selectedNode.id)) {
            delete state.node_map[state.selectedNode.id]; // 使用变量作为属性名
          }
        }
        if (state.selectedLine) {
          //删除相关的连接
          let targetLink = state.links.find(link => link.id == state.selectedLine);
          console.log("删除前",JSON.parse(JSON.stringify(targetLink)),JSON.parse(JSON.stringify(state.node_map)));
          if (state.node_map.hasOwnProperty(targetLink.source.id)) {

            //移除依赖关系
            let new_wires = state.node_map[targetLink.source.id].wires.map((innerArray, index) => {
                if (index === targetLink.sourcePort) {
                    return innerArray.filter(item => item !== targetLink.target.id);
                }
                return innerArray;
            });

            state.node_map[targetLink.source.id].wires = new_wires;// 使用变量作为属性名
            console.log(new_wires,targetLink.target.id,state.node_map[targetLink.source.id].wires);
            console.log("删除后",JSON.parse(JSON.stringify(targetLink)),JSON.parse(JSON.stringify(state.node_map)));
          }
          state.links = state.links.filter(link => {
            return link.id != state.selectedLine;
          });
          //删除节点中的连接信息
          // todo!!
        }
      });
    },
    setSelectedLine:(status) => {
      set(state => { state.selectedLine = status; });
    },
    save:async () => {
      let t1 = get().node_map;
      let flow = get().activeFlow;
      // console.log(t1);
      // console.log(Object.values(t1));
      set(state => {state.loading = true; state.isDeploying = false;});
      const result = await request("/api/v2/private/flow/save", "POST", "json", {filename:flow+".json",data:Object.values(t1)});
      if(result.success) {
        set(state => {
          state.loading = false;
          state.isDeploying = false;
        });
      } else {
        set(state => {state.loading = false; state.isDeploying = false;});
      }
      //let t2 = get("node_map");
    },
    updateNodeProps:(nodeData) => {
      set(state=>{
        const node = state.node_map[nodeData.id];
        state.node_map[nodeData.id].props = nodeData.props;
        state.node_map[nodeData.id].name = nodeData.name;
        //判断是否有对outputs数量做了修改
        if(nodeData.outputs) state.node_map[nodeData.id].outputs = nodeData.outputs;

        const labelParts = getLabelParts(node?.name || "", "red-ui-flow-node-label");
        const width = Math.max(node_width, 20 * (Math.ceil((labelParts.width + 50 + (node.inputs > 0 ? 7 : 0)) / 20)));
        const height = Math.max(6 + 24 * labelParts.lines.length, (node.outputs || 0) * 15, 30);
        state.node_map[nodeData.id].w = width;
        state.node_map[nodeData.id].h = height;
        //更新了信息，需要重新处理上下游links
      state.links = state.links.map(link => {
        if (link.source.id === nodeData.id) {
          if ((link.sourcePort+1) > nodeData.outputs) {
            return null;
          }
        }
        return link;
      }).filter(link => link !== null);

      // 根据outputs处理节点中的源节点的wires
      const diff = nodeData.outputs - state.node_map[nodeData.id].wires.length;
      if (diff > 0) {
        // 如果outputs大于wires的长度，则需要补充wires
        state.node_map[nodeData.id].wires = state.node_map[nodeData.id].wires.concat(Array(diff).fill([]));
      } else if (diff < 0) {
        // 如果outputs小于wires的长度，则需要移除wires
        state.node_map[nodeData.id].wires = state.node_map[nodeData.id].wires.slice(0, nodeData.outputs);
      }
      });
    },
    deploy: async () => {
      set(state => {state.loading = true; state.isDeploying = true});
      const result = await request("/api/v5/private/flow/deploy", "GET", "json", {});
      if(result.success) {
          // 重新部署后再从后台获取：保证状态最新
          // 只是保存的话，从后台拉取还是原来的状态，需要deploy后再拉取才有效
          await get().load_flow_data();
        set(state => {
          state.loading = false;
          state.isDeploying = false;
        });
      } else {
        set(state => {state.loading = false; state.isDeploying = false;});
      }
    },
    getFlowList: async () => {
      set(state => {state.loading = true; state.isDeploying = false;});
      await get().load_flow_data();
      const result = await request("/api/v5/private/flow/list", "GET", "json", {});
      if(result.success) {

        set(state => {
          const { links, node_map } = generateLinks(state.nodes, result.data[0] ?? state.activeFlow);
          state.links= links;
          state.node_map= node_map;
          state.loading = false;
          state.isDeploying = false;
          state.flowlist = result.data;
          state.activeFlow = result.data[0];
        });
      } else {
        set(state => {state.loading = false; state.isDeploying = false;});
      }
    },
    setActiveFlow: (key) => {
      set(state => {
        const { links, node_map } = generateLinks(state.nodes, key ?? state.activeFlow);
        state.activeFlow = key;
        state.links = links;
        state.node_map = node_map;
      });
    },
    setLassoStart: (val) => {
      set(state => {
        state.lassoStart = val;
      });
    },
    setLassoEnd: (val) => {
      set(state => {
        state.lassoEnd = val;
      });
    },
    setMousePt:(val) => {
      set(state => {
        state.mousePt = val;
      });
    },
    updateMovingSet:() => {
    set(state => {
        if (state.lassoStart && state.lassoEnd) {
          const minX = Math.min(state.lassoStart.x, state.lassoEnd.x);
          const maxX = Math.max(state.lassoStart.x, state.lassoEnd.x);
          const minY = Math.min(state.lassoStart.y, state.lassoEnd.y);
          const maxY = Math.max(state.lassoStart.y, state.lassoEnd.y);
          state.movingSet = Object.values(state.node_map).filter(node => node.x >= minX && node.x + node.w <= maxX && node.y >= minY && node.y + node.h <= maxY).map(node => node.id);
          console.log(JSON.stringify(state.movingSet));
        }
      });
    },
    copySelected:() => {
      set(state => {
          let copiedNodes = Object.values(state.node_map).filter(node => state.movingSet.includes(node.id));
          const idMapping = {};
          copiedNodes = copiedNodes.map(node => {
            const newId = nanoid();
            idMapping[node.id] = newId;
            return { ...node, id: newId };
          });
          copiedNodes = copiedNodes.map(node => {
            const newWires = node.wires.map(wireGroup =>
              wireGroup.filter(wireId => state.movingSet.includes(wireId)).map(wireId => idMapping[wireId])
            );
            return { ...node, wires: newWires };
            //state.node_map[idMapping[node.id]].wires = newWires;
          });
          console.log("copiedNodes:",JSON.stringify(copiedNodes));
          state.copiedNodes = copiedNodes;
        });
    },
    pasteSelected:() => {
      set(state => {
            if (state.copiedNodes.length > 0) {
              const minX = Math.min(...state.copiedNodes.map(node => node.x));
              const minY = Math.min(...state.copiedNodes.map(node => node.y));
              const offsetX = state.mousePt.x - minX;
              const offsetY = state.mousePt.y - minY;
              const newNodes = state.copiedNodes.map(node => ({
                ...node,
                x: node.x + offsetX,
                y: node.y + offsetY,
                z: state.activeFlow
              }));
              const t = [...Object.values(state.node_map),...newNodes];
              state.movingSet = newNodes.map(n => n.id);
              const { links, node_map } = generateLinks(t, state.activeFlow);
              //state.activeFlow = key;
              state.links = links;
              state.node_map = node_map;

            }
          });
    },
    // 添加一个新的方法来重置 SVG 位置
    resetSVGPosition: () => {
      set(state => {
        // console.warn('reset svg position', state.divContainerRef);
        if (state.divContainerRef) {
          state.divContainerRef.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        }
      });
    },
    // 添加保存当前流程位置的方法
    saveFlowPosition: (flowId) => {
      set(state => {
        if (state.divContainerRef && flowId) {
          state.flowPositions = {
            ...state.flowPositions,
            [flowId]: {
              top: state.divContainerRef.scrollTop,
              left: state.divContainerRef.scrollLeft
            }
          };
        }
      });
    },
    
    // 添加恢复流程位置的方法
    restoreFlowPosition: (flowId) => {
      set(state => {
        if (state.divContainerRef && flowId && state.flowPositions[flowId]) {
          state.divContainerRef.scrollTo({
            top: state.flowPositions[flowId].top,
            left: state.flowPositions[flowId].left,
            behavior: 'smooth'
          });
        }
      });
    },
    // 添加一个新方法用于搜索文本并滚动到对应节点
    scrollToNodeByText: (searchText) => {
      const state = get();
      if (!searchText || !state.divContainerRef) return false;
      
      // 搜索包含指定文本的节点
      const foundNode = Object.values(state.node_map).find(node => 
        node.name && node.name.toLowerCase().includes(searchText.toLowerCase())
      );
      
      if (foundNode) {
        // 计算节点在视图中的位置
        // 考虑到节点位置是相对于SVG的，我们需要滚动容器到适当位置
        const padding = 100; // 添加一些边距，使节点不会太靠近边缘
        
        state.divContainerRef.scrollTo({
          top: Math.max(0, foundNode.y - padding),
          left: Math.max(0, foundNode.x - padding),
          behavior: 'smooth'
        });
        
        // 可选：高亮显示找到的节点
        set(state => {
          state.movingSet = [foundNode.id];
        });
        
        return true;
      }
      
      return false;
    },
  }),
  {
    // 每个store唯一名称
    name: 'editor-storage',
    partialize: (state) =>
      {
        const { nodes, ...rest } = state;
        return {  };
      },
  },
  'editor',
)
const useEditorStore = createSelectors(useEditorStoreBase);
window.useEditorStore = useEditorStore;
// 3. 自动生成selector
export {useEditorStore}

export default useEditorStore;

// 在组件中的用法
// get the property
//const hello = useEditorStore.use.bears();
// get the action
//const setName = useEditorStore.use.setName();
//const reset = useEditorStore.use.();

// 防止相同值rerender
// Object pick, re-renders the component when either state.nuts or state.honey change
// const { hello } = useEditorStore(
//   useShallow((state) => ({ hello: state.hello})),
// )